import { useCallback } from 'react'
import { useDialog } from 'hooks/useDialog'
import { Sizes } from 'enums/sizes'
import {
  DocumentViewer,
  DocumentViewerAction,
  DocumentType,
  EmailConfig
} from './DocumentViewer'

export interface UseDocumentViewerDialogOptions {
  title: string
  storedFileId?: string
  blobUrl?: string
  mimeType?: string
  documentType?: DocumentType
  actions?: DocumentViewerAction[]
  showDefaultActions?: boolean
  size?: Sizes
  emailConfig?: EmailConfig
}

export const useDocumentViewerDialog = () => {
  const { openBlankDialog, closeDialog } = useDialog()

  const openDocumentViewer = useCallback(({
    title,
    storedFileId,
    blobUrl,
    mimeType = 'application/pdf',
    documentType,
    actions = [],
    showDefaultActions = true,
    size = Sizes['5xl'],
    emailConfig
  }: UseDocumentViewerDialogOptions) => {
    openBlankDialog(
      { size },
      <DocumentViewer
        title={title}
        storedFileId={storedFileId}
        blobUrl={blobUrl}
        mimeType={mimeType}
        documentType={documentType}
        onClose={closeDialog}
        actions={actions}
        showDefaultActions={showDefaultActions}
        emailConfig={emailConfig}
      />
    )
  }, [openBlankDialog, closeDialog])

  return { openDocumentViewer }
}
